import DefaultResults from '../components/VehicleSearch/DefaultResultsBeforeSearch.json';
import { IVehicleWithImages } from '../interfaces/VehicleImage';

export const VEHICLE_IMAGE_CDN = 'https://vehicles-cdn.24rent.fi/';

/** CDN variants: `medium` is the 300×200 card image, `mediumplus` the 600×400 enlarged view. */
export type VehicleImageSize = 'medium' | 'mediumplus';

/**
 * Builds the CDN URL for a vehicle image variant. The API names images
 * `<id>_<n>_large.jpeg`; the card swiper first maps `jpeg` → `webp` and then
 * swaps `large` for the wanted size. This helper only does the size swap so it
 * stays byte-for-byte compatible with the swiper's fallback names.
 */
export function vehicleImageUrl(imageName: string, size: VehicleImageSize): string {
    return VEHICLE_IMAGE_CDN + imageName.replace('large', size);
}

/**
 * The card image of the first default vehicle. It is the largest element in
 * the homepage's first viewport (the LCP element) and is inserted by React
 * after the bundle has executed, so unless it is preloaded the browser only
 * discovers it seconds after first paint. The build (vite.config.ts) injects a
 * preload for this URL into index.html and writes it to
 * build/first-vehicle-image.json for the WordPress plugin.
 *
 * Returns null when the default results carry no usable image, in which case
 * nothing is preloaded.
 */
export function firstDefaultVehicleCardImageUrl(
    vehicles: IVehicleWithImages[] = DefaultResults.vehicles,
): string | null {
    const imageName = vehicles[0]?.vehicleImages?.[0]?.imageName;
    if (typeof imageName !== 'string' || imageName.length === 0) {
        return null;
    }
    return vehicleImageUrl(imageName.replace('jpeg', 'webp'), 'medium');
}
